import { ActionReducerMap } from '@ngrx/store';

import { transactionsReducer } from './transactions.reducer';
import { TransactionsState } from '../transactions.state';

export const reducers: ActionReducerMap<TransactionsState> = {
    transactions: transactionsReducer,
};
